import { useState } from "react";
import BreadcrumbItem from "./BreadcrumbItem";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import Skeleton from "react-loading-skeleton";

// Define the animation style
const animationStyle = {
  animation: "fadeIn 0.5s ease-in-out",
};

const InnerBannerBreadcrumb = ({
  bannerImage,
  title,
  titleLink,
  levelTwo,
  titleTwo,
  titleThree,
  levelThree,
  isActive,
  titleLink2,
}) => {
  const { getText } = useLanguageTranslation();
  const [imageLoaded, setImageLoaded] = useState(false);

  const imageUrl = bannerImage?.startsWith("image")
    ? process.env.REACT_APP_IMAGE_URL_FRONTEND + bannerImage
    : process.env.REACT_APP_IMAGE_URL + bannerImage;

  return (
    <div className="inner_banner">
      <div style={animationStyle} className="innerbanner-h">
        {!imageLoaded && <Skeleton height={400} width="100%" />}
        <img
          alt={""}
          src={imageUrl}
          onLoad={() => setImageLoaded(true)}
          style={{ display: imageLoaded ? "block" : "none" }}
        />
        <div className="container">
          <div className="breadcrum-area">
            <h1 className="banner_title">{isActive}</h1>

            <div className="region region-breadcrumb">
              <div
                id="block-tdb-breadcrumbs"
                className="block block-system block-system-breadcrumb-block"
              >
                <nav
                  className="breadcrumb"
                  role="navigation"
                  aria-label="Breadcrumb"
                >
                  <ol className="breadcrumb">
                    <BreadcrumbItem to="/">
                      {getText("Home", "होम")}
                    </BreadcrumbItem>
                    <BreadcrumbItem to={titleLink} isActive={isActive}>
                      {title}
                    </BreadcrumbItem>
                    {levelTwo && (
                      <BreadcrumbItem
                        to={levelThree ? titleLink2 : null}
                        isActive={isActive}
                      >
                        {titleTwo}
                      </BreadcrumbItem>
                    )}
                    {levelThree && (
                      <BreadcrumbItem to={null} isActive={isActive}>
                        {titleThree}
                      </BreadcrumbItem>
                    )}
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InnerBannerBreadcrumb;
